module.exports = __webpack_public_path__ + "static/media/icon-tiktok.d25cb68f.svg";